import { Component} from '@angular/core';
import { AuthService } from './shared/services/auth.service';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent {
  title = 'app';
  hideFooter = false;

  constructor(public auth: AuthService, private router: Router) {
    auth.handleAuthentication();
    
    // Check current route and hide footer on copilot pages
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.hideFooter = event.url.includes('/xwai');
    });
  }
}
